import PageLoader from 'components/Shared/PageLoader';
import Toast from 'components/Shared/Toast';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import tokenService from 'services/token';
import userService from 'services/user';
import loggedUserService from 'services/userService';

interface IProps {
  match: any;
  history: any;
}

const LoginAsSupport = ({ match, history }: IProps) => {
  let isSupport = false;
  if (match.path === '/login/as_support/:email/:hash/:page?') {
    isSupport = true;
  }
  localStorage.setItem('isSupport', isSupport.toString());
  useEffect(() => {
    const { hash, email, page } = match.params;
    userService.loginAs({ hash, email }).subscribe(
      user => {
        if (user.jwt_token) {
          tokenService.setTokens({
            jwt_token: user.jwt_token,
            jwt_refresh_token: user.jwt_refresh_token,
          });
          loggedUserService.setUser({ isSupport, ...user, isLoginAs: true });

          if (page) {
            history.push('/' + page + '/');
          } else {
            history.push('/event/');
          }
        }

        if (user.error) {
          history.push('/login/');
          Toast.error(user.error);
        }
      },
      err => {
        console.log(err);
        if (err.message === 'Request failed with status code 403') {
          Toast.error(
            'Permissão Negada. O administrador desta conta não lhe concedeu privilégio para acessar este recurso',
            6000,
          );
        }
      },
    );
  });

  return <PageLoader />;
};

export default withRouter(LoginAsSupport);
